import mutationCreator from './mutation-creator';
import mutationInverter from './mutation-inverter';

export default {
  mutationCreator,
  mutationInverter,
};
